import { exportTeamReprovisionRunsQuerySchema, listMembershipSyncRunsQuerySchema, listMembershipSyncRunsResponseSchema, listTeamReprovisionRunResultsQuerySchema, listTeamReprovisionRunResultsResponseSchema, listTeamReprovisionRunsQuerySchema, listTeamReprovisionRunsResponseSchema, reprovisionAllResponseSchema, reprovisionTeamParamsSchema, reprovisionTeamResponseSchema, syncTeamMembershipsBodySchema, syncTeamMembershipsResponseSchema, teamReprovisionRunIdParamsSchema, } from '../endpoints/admin-teams.js';
import { addTeamAdminBodySchema, addTeamAdminResponseSchema, addTeamMemberBodySchema, addTeamMemberResponseSchema, addTeamReviewerBodySchema, addTeamReviewerResponseSchema, adoPushPayloadSchema, approveSubmissionBodySchema, approveSubmissionResponseSchema, bannerStateSchema, collectContributionsResponseSchema, createSubmissionFieldsSchema, createSubmissionResponseSchema, createTeamBodySchema, createTeamResponseSchema, deprecatePluginBodySchema, deprecatePluginResponseSchema, exportAuditQuerySchema, exportFlagsQuerySchema, exportMetricsQuerySchema, exportPluginsQuerySchema, exportRolesQuerySchema, exportSourcesQuerySchema, exportSubmissionsQuerySchema, exportSweepsQuerySchema, exportTeamsQuerySchema, exportUsersQuerySchema, flagKeyParamSchema, forceHubPrAutoCompleteParamsSchema, forceHubPrAutoCompleteResponseSchema, forceSyncSourceParamsSchema, forceSyncSourceResponseSchema, getAuthMeResponseSchema, getMetricsContributionsByTeamResponseSchema, getMetricsContributionsTimeseriesResponseSchema, getMetricsInstallsQuerySchema, getMetricsInstallsResponseSchema, getMetricsPluginsTimeseriesResponseSchema, getMetricsSummaryResponseSchema, getMetricsTeamActivityQuerySchema, getMetricsTeamActivityResponseSchema, getMetricsUsersTimeseriesResponseSchema, getPluginByNameParamsSchema, getPluginByNameResponseSchema, getPluginResponseSchema, getSourceParamsSchema, getSourceResponseSchema, getStatusResponseSchema, getSubmissionResponseSchema, getTeamByNameParamsSchema, getTeamByNameResponseSchema, getTeamManifestParamsSchema, getTeamResponseSchema, getUserResponseSchema, getUserTeamRolesResponseSchema, hubOrphansResponseSchema, hubQueueResponseSchema, listAuditQuerySchema, listAuditResponseSchema, listCategoriesQuerySchema, listCategoriesResponseSchema, listFlagsQuerySchema, listFlagsResponseSchema, listPermissionsResponseSchema, listPluginsQuerySchema, listPluginsResponseSchema, listRolesQuerySchema, listRolesResponseSchema, listSourcesQuerySchema, listSourcesResponseSchema, listSubmissionsQuerySchema, listSubmissionsResponseSchema, listSweepJobsQuerySchema, listSweepJobsResponseSchema, listSweepsQuerySchema, listSweepsResponseSchema, listSyncJobPluginResultsQuerySchema, listSyncJobPluginResultsResponseSchema, listSyncJobsParamsSchema, listSyncJobsQuerySchema, listSyncJobsResponseSchema, listTeamAdminsQuerySchema, listTeamAdminsResponseSchema, listTeamMembersQuerySchema, listTeamMembersResponseSchema, listTeamReviewersQuerySchema, listTeamReviewersResponseSchema, listTeamsQuerySchema, listTeamsResponseSchema, listUsersQuerySchema, listUsersResponseSchema, liveResponseSchema, metricsRangeQuerySchema, overrideAdoIdentityBodySchema, overrideAdoIdentityResponseSchema, pluginIdParamSchema, reactivateSourceParamsSchema, reactivateSourceResponseSchema, readyResponseSchema, refreshTemplateParamsSchema, refreshTemplateResponseSchema, registerHookParamsSchema, registerHookResponseSchema, rejectSubmissionBodySchema, rejectSubmissionResponseSchema, removeTeamAdminParamsSchema, removeTeamMemberParamsSchema, removeTeamReviewerParamsSchema, requeueSubmissionResponseSchema, resolveAdoIdentityResponseSchema, rotateWebhookSecretBodySchema, rotateWebhookSecretResponseSchema, sourceIdParamSchema, submissionIdParamSchema, sweepJobsParamsSchema, syncJobPluginResultsParamsSchema, syncSourceBodySchema, syncSourceParamsSchema, syncSourceResponseSchema, teamIdParamSchema, triggerSweepResponseSchema, unmarkDeprecatedPluginBodySchema, unmarkDeprecatedPluginResponseSchema, unyankPluginBodySchema, unyankPluginResponseSchema, updateFlagBodySchema, updateFlagResponseSchema, updatePluginBodySchema, updatePluginResponseSchema, updateRoleBodySchema, updateRoleParamsSchema, updateRoleResponseSchema, updateTeamBodySchema, updateTeamResponseSchema, updateUserRolesBodySchema, updateUserRolesResponseSchema, updateUserTrustedBodySchema, updateUserTrustedResponseSchema, userIdParamSchema, webhookAckResponseSchema, yankPluginBodySchema, yankPluginResponseSchema, } from '../endpoints/index.js';
import { manifestSchema } from '../schemas/manifest.js';
/**
 * Common error codes emitted by the global error handler in
 * `marketplace-api/src/plugins/error-handler.ts`. Routes inherit these
 * implicitly; per-route registries below add only the route-specific codes
 * (e.g. `PLUGIN_NOT_FOUND`).
 */
export const COMMON_ERROR_CODES = Object.freeze({
    validation: ['VALIDATION_ERROR'],
    rateLimit: ['RATE_LIMITED'],
    unauthenticated: [
        'MISSING_TOKEN',
        'MALFORMED_TOKEN',
        'EXPIRED_TOKEN',
        'INVALID_SIGNATURE',
        'INVALID_AUDIENCE',
        'INVALID_ISSUER',
    ],
    forbidden: ['FORBIDDEN'],
    internal: ['INTERNAL_ERROR'],
});
/**
 * Canonical route registry. Order is preserved in the generated spec
 * (paths grouped by tag, methods within a path grouped by registry order).
 *
 * Adding a new route:
 *   1. Add to this array in the matching tag block.
 *   2. The build script regenerates `openapi.json` and the API reference
 *      doc on the next `pnpm build:openapi` / `pnpm --filter docs-site build`.
 */
export const routeRegistry = Object.freeze([
    // ────────────────────────────────────────────────────────────────────
    // admin — operator-facing read-only diagnostic surfaces
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/admin/hub-queue',
        tag: 'admin',
        operationId: 'admin_hub_queue',
        summary: 'List plugins awaiting Hub PR merge',
        description: 'Returns plugins whose sync-repo Hub PR is open but not yet merged (`hub_pr_url IS NOT NULL AND hub_listed_at IS NULL`). Operators use this to track PRs awaiting marketplace-admin review against `Cotality.Marketplace.Hub`. Read-only; no audit row, no mutation. Default sort is newest-first by `created_at`. See ADR-0003 + Task 12 of the Hub bootstrap plan.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        responses: {
            '200': { description: 'Plugins awaiting Hub PR merge', schema: hubQueueResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/hub/orphans',
        tag: 'admin',
        operationId: 'admin_hub_orphans',
        summary: 'List Hub-listed plugins missing from the catalog (orphans)',
        description: 'Returns the persisted `hub_orphan_listings`: names present in the Hub `marketplace.json` with no matching catalog row (e.g. a plugin the sync validator skipped on a secret-scan finding, never upserted). Distinct from the hub-queue (pending PRs): an orphan is listed in the Hub but missing from our catalog. Upserted by the reconcile mirror pass, cleared when the catalog row appears or the name leaves the Hub. Sorted oldest-first by `first_seen_at` so the longest-orphaned rows surface at the top. Read-only; no audit row, no mutation.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        responses: {
            '200': {
                description: 'Hub-listed plugins missing from the catalog',
                schema: hubOrphansResponseSchema,
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'POST',
        path: '/api/admin/hub-queue/{pluginId}/force-auto-complete',
        tag: 'admin',
        operationId: 'admin_hub_queue_force_auto_complete',
        summary: "Force auto-complete on a plugin's Hub PR (admin)",
        description: "Operator escape hatch (Task 10, ADR-0003) that turns the manual `PATCH` used to unblock four stalled Hub PRs on 2026-07-29 into a supported action: re-issues `AdoClient.setPullRequestAutoComplete` (ADO's PR *create* endpoint silently discards `completionOptions`/`autoCompleteSetBy`) for exactly the cases the automation deliberately does not handle on its own — `hub-pr-auto-complete` is off but this PR should still merge, or the reconcile-sync self-heal sweep is itself failing. Keyed by `pluginId`, never a raw ADO PR id — resolved through `plugins.hub_pr_url` so an operator can only target a rollup PR the marketplace itself opened, never a human's PR. Writes a `plugin.hub_pr_force_auto_complete` audit row AFTER the ADO PATCH succeeds. 404 when the plugin is missing, soft-deleted, or has no open Hub PR; 400 when `hub_pr_url` has no parseable PR id; 502 when ADO rejects the PATCH; 503 when the route's ADO client / Hub repo id are not configured.",
        permission: 'admin:sync',
        rateLimitTier: 'authedWrite',
        request: { params: forceHubPrAutoCompleteParamsSchema },
        responses: {
            '200': {
                description: "Auto-complete set on the plugin's Hub PR",
                schema: forceHubPrAutoCompleteResponseSchema,
            },
            '400': {
                description: 'hub_pr_url has no parseable PR id',
                errorCodes: ['HUB_PR_URL_UNPARSEABLE'],
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': {
                description: 'Plugin missing, soft-deleted, or has no open Hub PR',
                errorCodes: ['PLUGIN_NOT_FOUND'],
            },
            '502': {
                description: 'ADO rejected the auto-complete request',
                errorCodes: ['ADO_UNAVAILABLE'],
            },
            '503': {
                description: 'Force auto-complete not configured',
                errorCodes: ['HUB_AUTO_COMPLETE_UNAVAILABLE'],
            },
        },
    },
    {
        method: 'POST',
        path: '/api/admin/sync/sweep',
        tag: 'admin',
        operationId: 'admin_sync_sweep',
        summary: 'Trigger a manual reconcile sweep',
        description: 'Opens a manual reconcile sweep: reclaims any crash-stuck `running` row older than 20 min, inserts a fresh `running` sweep row (the partial unique index is the atomic guard), enqueues a `reconcile-sync` job carrying the sweep id, and writes an `admin.sync_sweep` audit row. A concurrent trigger while a fresh sweep runs returns 409 `SWEEP_ALREADY_RUNNING`. Spec 2026-06-15 §3 / §7.',
        permission: 'admin:sync',
        rateLimitTier: 'authedWrite',
        responses: {
            '202': {
                description: 'Sweep opened + reconcile-sync enqueued',
                schema: triggerSweepResponseSchema,
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '409': { description: 'A sweep is already running', errorCodes: ['SWEEP_ALREADY_RUNNING'] },
        },
    },
    {
        method: 'POST',
        path: '/api/admin/sync/sources/{id}',
        tag: 'admin',
        operationId: 'admin_sync_source',
        summary: 'Force re-sync a single source (admin)',
        description: "Admin counterpart to `POST /api/sources/:id/sync` — gated by `admin:sync` (not team-scoped) so a marketplace admin can force-resync any source cross-team. Resolves the source repo's branch HEAD and enqueues a `sync-repo` job for it (`sweep_id` null), writing an `admin.sync_source` audit row. 404 when the source is missing or not active; 502 when ADO returns no HEAD; 503 when the force-resync deps are not configured. Spec 2026-06-15 §3.",
        permission: 'admin:sync',
        rateLimitTier: 'authedWrite',
        request: { params: forceSyncSourceParamsSchema },
        responses: {
            '202': { description: 'Force re-sync enqueued', schema: forceSyncSourceResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Active source not found', errorCodes: ['SOURCE_NOT_FOUND'] },
            '502': { description: 'ADO returned no HEAD; retry', errorCodes: ['ADO_UNAVAILABLE'] },
            '503': { description: 'Force re-sync not configured', errorCodes: ['SYNC_UNAVAILABLE'] },
        },
    },
    {
        method: 'POST',
        path: '/api/admin/sync/contributions',
        tag: 'admin',
        operationId: 'admin_collect_contributions',
        summary: 'Collect contributions now (admin)',
        description: 'Enqueues an immediate `collect-contributions` run instead of waiting for the 01:00 UTC schedule — the operator surface for rollout step 2 (first backfill) and for re-collecting after an ADO outage. Writes an `admin.collect_contributions` audit row in its own transaction, which commits BEFORE the enqueue rather than alongside it: a BullMQ `add()` cannot be rolled back with Postgres, so the audit row records that an operator triggered a run, and a subsequent enqueue failure surfaces as a 5xx instead of erasing the audit trail. Idempotent by construction: the collector upserts on (date_utc, source_id, author_email) and only advances a source watermark on success.',
        permission: 'admin:sync',
        rateLimitTier: 'authedWrite',
        responses: {
            '202': {
                description: 'Collection enqueued',
                schema: collectContributionsResponseSchema,
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '503': { description: 'Collector not configured', errorCodes: ['SYNC_UNAVAILABLE'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/sync/sweeps',
        tag: 'admin',
        operationId: 'admin_sync_sweeps',
        summary: 'List reconcile sweep history',
        description: 'Paginated reconcile-sweep history, newest first. The admin dashboard landing summary reuses this with `pageSize=1`. Supports `sort` (signed comma-joined field: status, trigger, startedAt, finishedAt) and `status` (comma-joined filter: running, succeeded, failed). Read-only; no audit row. Spec 2026-06-15 §3.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: { query: listSweepsQuerySchema },
        responses: {
            '200': { description: 'Paginated sweep history', schema: listSweepsResponseSchema },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/sync/sweeps/export',
        tag: 'admin',
        operationId: 'admin_sync_sweeps_export',
        summary: 'Export reconcile sweep history as CSV',
        description: 'Exports all sweeps matching the filter + sort params as a text/csv attachment. Same filter surface as admin_sync_sweeps but without pagination. Capped at 50 000 rows server-side.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: { query: exportSweepsQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/sync/sweeps/{id}/jobs',
        tag: 'admin',
        operationId: 'admin_sync_sweep_jobs',
        summary: 'List the sync jobs produced by one sweep',
        description: 'The `sync_jobs` rows fanned out by one reconcile sweep (drill-down), newest first, joined to the source display name. Read-only; no audit row. Spec 2026-06-15 §3.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: { params: sweepJobsParamsSchema, query: listSweepJobsQuerySchema },
        responses: {
            '200': { description: 'Paginated sweep jobs', schema: listSweepJobsResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/sync/jobs/{id}/plugin-results',
        tag: 'admin',
        operationId: 'admin_sync_job_plugin_results',
        summary: 'List per-plugin results for one sync job',
        description: 'The `sync_job_plugin_results` rows for one `sync_jobs` row — the structured, queryable per-plugin detail (outcome + redacted validator findings + actionable message) behind the lossy 200-char `sync_jobs.error`. Lets operators see exactly which plugins synced, were skipped on a secret-scan finding, collided, or had bad JSON. Oldest first (stable `created_at`, then `id`). Read-only; no audit row. Spec 2026-06-15 §3.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: {
            params: syncJobPluginResultsParamsSchema,
            query: listSyncJobPluginResultsQuerySchema,
        },
        responses: {
            '200': {
                description: 'Paginated per-plugin results',
                schema: listSyncJobPluginResultsResponseSchema,
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // admin — team re-provision
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'POST',
        path: '/api/admin/teams/{id}/reprovision',
        tag: 'admin',
        operationId: 'admin_team_reprovision',
        summary: 'Re-provision a single team (ensure-only)',
        description: 'Opens a single-team re-provision run and enqueues a `reprovision-team` job. Idempotent, ensure-only: adopt/create the ADO Admins+Reviewers Teams, persist their ids, seed Admins from the current roster (add-only), ensure the main branch policy (create-if-absent), ensure the repo ACL. Never removes members or downgrades settings. 409 when a run is already in progress.',
        permission: 'teams:reprovision',
        rateLimitTier: 'authedWrite',
        request: { params: reprovisionTeamParamsSchema },
        responses: {
            '202': { description: 'Run opened + job enqueued', schema: reprovisionTeamResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
            '409': { description: 'A run is already in progress', errorCodes: ['RUN_ALREADY_RUNNING'] },
        },
    },
    {
        method: 'POST',
        path: '/api/admin/teams/reprovision-all',
        tag: 'admin',
        operationId: 'admin_team_reprovision_all',
        summary: 'Re-provision all provisioned teams (ensure-only)',
        description: 'Opens a bulk re-provision run across every non-deleted provisioned team (ado_repo_id not a pending placeholder) and enqueues a `reprovision-team` job. Same ensure-only semantics as the single-team route. 409 when a run is already in progress.',
        permission: 'teams:reprovision',
        rateLimitTier: 'authedWrite',
        responses: {
            '202': { description: 'Run opened + job enqueued', schema: reprovisionAllResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '409': { description: 'A run is already in progress', errorCodes: ['RUN_ALREADY_RUNNING'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/teams/reprovision-runs',
        tag: 'admin',
        operationId: 'admin_team_reprovision_runs',
        summary: 'List team re-provision run history',
        description: 'Paginated re-provision run history, newest first. Supports `sort` (signed comma-joined field: status, trigger, startedAt) and `status` (comma-joined filter: running, succeeded, failed). Read-only; no audit row.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: { query: listTeamReprovisionRunsQuerySchema },
        responses: {
            '200': {
                description: 'Paginated run history',
                schema: listTeamReprovisionRunsResponseSchema,
            },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/teams/reprovision-runs/export',
        tag: 'admin',
        operationId: 'admin_team_reprovision_runs_export',
        summary: 'Export team re-provision run history as CSV',
        description: 'Exports all reprovision runs matching the filter + sort params as a text/csv attachment. Same filter surface as admin_team_reprovision_runs but without pagination. Capped at 50 000 rows server-side.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: { query: exportTeamReprovisionRunsQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/teams/reprovision-runs/{id}/results',
        tag: 'admin',
        operationId: 'admin_team_reprovision_run_results',
        summary: 'List per-team results for one re-provision run',
        description: 'The per-team outcomes within one re-provision run (drill-down), newest first. Read-only; no audit row.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: {
            params: teamReprovisionRunIdParamsSchema,
            query: listTeamReprovisionRunResultsQuerySchema,
        },
        responses: {
            '200': {
                description: 'Paginated run results',
                schema: listTeamReprovisionRunResultsResponseSchema,
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // admin — membership sync (ADO-authoritative: adopts members added
    // directly in ADO into the marketplace DB)
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'POST',
        path: '/api/admin/teams/membership-sync',
        tag: 'admin',
        operationId: 'admin_team_membership_sync',
        summary: 'Sync team memberships from ADO (adopt, deactivate, and push; ADO-authoritative)',
        description: 'Opens a membership-sync run and enqueues the sync job. Reconciles marketplace team membership against the ADO Teams roster: adopts members added directly in ADO, deactivates members removed there, and pushes back any marketplace-only members ADO is missing. Scoped to a single team when `teamId` is given, otherwise runs across every provisioned team. `dryRun: true` computes and persists counts without applying changes. 404 when `teamId` is given but not found. 409 when a run is already in progress.',
        permission: 'teams:reprovision',
        rateLimitTier: 'authedWrite',
        request: { body: syncTeamMembershipsBodySchema },
        responses: {
            '202': {
                description: 'Run opened + job enqueued',
                schema: syncTeamMembershipsResponseSchema,
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found (when teamId given)', errorCodes: ['TEAM_NOT_FOUND'] },
            '409': { description: 'A run is already in progress', errorCodes: ['RUN_ALREADY_RUNNING'] },
        },
    },
    {
        method: 'GET',
        path: '/api/admin/teams/membership-sync-runs',
        tag: 'admin',
        operationId: 'admin_team_membership_sync_runs',
        summary: 'List membership-sync run history',
        description: 'Paginated membership-sync run history, newest first. Supports `sort` (signed comma-joined field: status, trigger, startedAt) and `status` (comma-joined filter: running, succeeded, failed). Read-only; no audit row.',
        permission: 'admin:view',
        rateLimitTier: 'authedRead',
        request: { query: listMembershipSyncRunsQuerySchema },
        responses: {
            '200': {
                description: 'Paginated run history',
                schema: listMembershipSyncRunsResponseSchema,
            },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // health (anonymous)
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/health/live',
        tag: 'health',
        operationId: 'health_live',
        summary: 'Liveness probe',
        description: 'Unconditional liveness probe consumed by ACA startup checks. Returns 200 as long as the event loop is responsive.',
        anonymous: true,
        authScheme: 'none',
        responses: {
            '200': { description: 'Service is alive', schema: liveResponseSchema, raw: true },
        },
    },
    {
        method: 'GET',
        path: '/health/ready',
        tag: 'health',
        operationId: 'health_ready',
        summary: 'Readiness probe',
        description: 'Reports per-dependency readiness (DB, Redis, App Insights). Returns 503 with the same body shape when any dependency is unhealthy.',
        anonymous: true,
        authScheme: 'none',
        responses: {
            '200': { description: 'Service is ready', schema: readyResponseSchema, raw: true },
            '503': {
                description: 'One or more dependencies are degraded',
                schema: readyResponseSchema,
                raw: true,
            },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // manifest (anonymous, envelope bypass)
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/.well-known/marketplace.json',
        tag: 'manifest',
        operationId: 'manifest_root',
        summary: 'Root marketplace manifest',
        description: 'Public marketplace index consumed by Claude Code. The response is a bare manifest object — the success/data envelope is intentionally bypassed for compatibility with external clients. Cached for 60 s; honours `If-None-Match`.',
        anonymous: true,
        authScheme: 'none',
        rateLimitTier: 'publicManifest',
        responses: {
            '200': { description: 'Marketplace manifest', schema: manifestSchema, raw: true },
            '304': { description: 'Not modified (matches `If-None-Match`)', empty: true, raw: true },
        },
    },
    {
        method: 'GET',
        path: '/api/.well-known/marketplace.{teamName}.json',
        tag: 'manifest',
        operationId: 'manifest_team',
        summary: 'Per-team marketplace manifest',
        description: 'Team-scoped marketplace manifest. Same envelope-bypass / caching rules as the root manifest. Returns 404 when the team slug is unknown or has no active plugins.',
        anonymous: true,
        authScheme: 'none',
        rateLimitTier: 'publicManifest',
        request: { params: getTeamManifestParamsSchema },
        responses: {
            '200': { description: 'Team manifest', schema: manifestSchema, raw: true },
            '304': { description: 'Not modified (matches `If-None-Match`)', empty: true, raw: true },
            '404': { description: 'Team manifest not found', errorCodes: ['NOT_FOUND'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // status (anonymous — public maintenance-mode probe)
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/status',
        tag: 'status',
        operationId: 'status_get',
        summary: 'Public maintenance-mode probe',
        description: 'Anonymous status probe used by the SPA to decide whether to render the maintenance page. Reports the `maintenance-mode` feature-flag state to every caller (anon or authed). `/api/flags` requires `flags:view` so this endpoint is the smallest surface that lets every visitor learn the kill-switch state. Anonymous reachability is contract-derived: this route carries `anonymous: true`, which the API gate resolves via `isAnonymousOperation` (`marketplace-api/src/plugins/auth.ts`); the SWA route carveout (`marketplace-ui/public/staticwebapp.config.template.json`) exposes it at the edge.',
        anonymous: true,
        authScheme: 'none',
        responses: {
            '200': { description: 'Maintenance-mode state', schema: getStatusResponseSchema },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // banner (admin — edits the sidebar announcement banner)
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/banner',
        tag: 'banner',
        operationId: 'banner_get',
        summary: 'Get the editable sidebar banner state',
        description: 'Admin read of the full banner state (incl. saved content while disabled), used to prefill the Banner admin form. The PUBLIC render shape rides GET /api/status (banner field). Gated banner:update.',
        permission: 'banner:update',
        rateLimitTier: 'authedRead',
        responses: {
            '200': { description: 'Banner state', schema: bannerStateSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'PUT',
        path: '/api/banner',
        tag: 'banner',
        operationId: 'banner_update',
        summary: 'Update the sidebar banner',
        description: 'Sets the sidebar-banner flag enabled state + content. Cannot enable an empty-title banner. Emits a banner.updated audit row. Gated banner:update.',
        permission: 'banner:update',
        rateLimitTier: 'authedWrite',
        request: { body: bannerStateSchema },
        responses: {
            '200': { description: 'Updated banner state', schema: bannerStateSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // auth (any signed-in user)
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/auth/me',
        tag: 'auth',
        operationId: 'auth_me',
        summary: 'Current principal + effective permissions',
        description: 'Returns the authenticated principal expanded with role + permission rows resolved from DB. The UI calls this once on boot to learn what gates it has cleared. No `requirePermissions` — any signed-in user can call.',
        rateLimitTier: 'authedRead',
        responses: {
            '200': { description: 'The current user', schema: getAuthMeResponseSchema },
            '401': {
                description: 'Missing or malformed JWT (Entra)',
                errorCodes: [
                    'MISSING_TOKEN',
                    'MALFORMED_TOKEN',
                    'EXPIRED_TOKEN',
                    'INVALID_SIGNATURE',
                    'INVALID_AUDIENCE',
                    'INVALID_ISSUER',
                ],
            },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // users
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/users',
        tag: 'users',
        operationId: 'users_list',
        summary: 'List users',
        description: 'Paginated admin listing of users with their per-team role grants.',
        permission: 'users:view',
        rateLimitTier: 'authedRead',
        request: { query: listUsersQuerySchema },
        responses: {
            '200': { description: 'Paginated user list', schema: listUsersResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '401': {
                description: 'Missing or malformed JWT (Entra)',
                errorCodes: [
                    'MISSING_TOKEN',
                    'MALFORMED_TOKEN',
                    'EXPIRED_TOKEN',
                    'INVALID_SIGNATURE',
                    'INVALID_AUDIENCE',
                    'INVALID_ISSUER',
                ],
            },
            '403': { description: 'Missing required permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/users/{id}',
        tag: 'users',
        operationId: 'users_get',
        summary: 'Get a single user',
        description: 'Single-resource fetch — same row shape as the list.',
        permission: 'users:view',
        rateLimitTier: 'authedRead',
        request: { params: userIdParamSchema },
        responses: {
            '200': { description: 'Admin user row', schema: getUserResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'User not found', errorCodes: ['USER_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/users/{id}/team-roles',
        tag: 'users',
        operationId: 'users_get_team_roles',
        summary: "List a user's team admin/reviewer memberships",
        description: 'Per-team admin/reviewer state for the user, plus the ADO-org membership probe result. Powers the Teams tab of the admin user detail sheet.',
        permission: 'users:view',
        rateLimitTier: 'authedRead',
        request: { params: userIdParamSchema },
        responses: {
            '200': {
                description: 'Per-team admin/reviewer state',
                schema: getUserTeamRolesResponseSchema,
            },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'User not found', errorCodes: ['USER_NOT_FOUND'] },
        },
    },
    {
        method: 'PATCH',
        path: '/api/users/{id}/roles',
        tag: 'users',
        operationId: 'users_update_roles',
        summary: 'Apply role-grant deltas to a user',
        description: "Applies an atomic add/remove delta to a user's role grants. Self-role-edit is rejected with 403 SELF_EDIT_FORBIDDEN. The 409 LAST_SUPER_ADMIN guard prevents reducing the global super_admin pool below two.",
        permission: 'users:update_roles',
        rateLimitTier: 'authedWrite',
        request: { params: userIdParamSchema, body: updateUserRolesBodySchema },
        responses: {
            '200': { description: 'Counts of applied deltas', schema: updateUserRolesResponseSchema },
            '400': {
                description: 'Validation failure, a team_admin delta (managed via the team roster endpoints), or an unsatisfiable role delta',
                errorCodes: ['VALIDATION_ERROR', 'TEAM_ADMIN_NOT_ALLOWED', 'INVALID_ROLE_DELTA'],
            },
            '403': {
                description: 'Self-edit or missing permission',
                errorCodes: ['SELF_EDIT_FORBIDDEN', 'FORBIDDEN'],
            },
            '409': {
                description: 'Would leave fewer than two super_admins',
                errorCodes: ['LAST_SUPER_ADMIN'],
            },
        },
    },
    {
        method: 'PATCH',
        path: '/api/users/{id}/trusted',
        tag: 'users',
        operationId: 'users_update_trusted',
        summary: "Toggle a user's `isTrusted` flag",
        description: 'Super-admin only. Auto-approves submissions from a trusted user.',
        permission: 'users:toggle_trusted',
        rateLimitTier: 'authedWrite',
        request: { params: userIdParamSchema, body: updateUserTrustedBodySchema },
        responses: {
            '200': { description: 'Updated flag', schema: updateUserTrustedResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'User not found', errorCodes: ['USER_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/users/export',
        tag: 'users',
        operationId: 'users_export',
        summary: 'Export users as CSV',
        description: 'Exports all users matching the filter + sort params as a text/csv attachment. Same filter surface as users_list (search, roleName, isTrusted, teamId, sort) but without pagination. Capped at 50 000 rows server-side.',
        permission: 'users:view',
        rateLimitTier: 'authedRead',
        request: { query: exportUsersQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'POST',
        path: '/api/users/{id}/ado-identity/resolve',
        tag: 'users',
        operationId: 'users_resolve_ado_identity',
        summary: "Re-run resolution of a user's ADO identity",
        description: "Re-runs `ensureOriginId` against Microsoft Graph for the user's email. On `ambiguous`, `candidates` lists the matching Graph users so an admin can pick the correct one via the override endpoint.",
        permission: 'users:manage_ado_identity',
        rateLimitTier: 'authedWrite',
        request: { params: userIdParamSchema },
        responses: {
            '200': { description: 'Resolution outcome', schema: resolveAdoIdentityResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'User not found', errorCodes: ['USER_NOT_FOUND'] },
            '503': {
                description: 'Graph client not wired (dev/test)',
                errorCodes: ['GRAPH_UNAVAILABLE'],
            },
        },
    },
    {
        method: 'PUT',
        path: '/api/users/{id}/ado-identity',
        tag: 'users',
        operationId: 'users_override_ado_identity',
        summary: "Manually set a user's ADO origin id",
        description: "Manual override of a user's ADO origin id (Graph object id), used when resolution is ambiguous or not_found. Rejects an oid not present in the directory (Entra) or already linked to another user.",
        permission: 'users:manage_ado_identity',
        rateLimitTier: 'authedWrite',
        request: { params: userIdParamSchema, body: overrideAdoIdentityBodySchema },
        responses: {
            '200': { description: 'Persisted origin id', schema: overrideAdoIdentityResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'User not found', errorCodes: ['USER_NOT_FOUND'] },
            '409': {
                description: 'Origin id already linked to another user',
                errorCodes: ['ORIGIN_ID_CONFLICT'],
            },
            '422': {
                description: 'Origin id not present in the directory (Entra)',
                errorCodes: ['ORIGIN_ID_NOT_IN_DIRECTORY'],
            },
            '503': {
                description: 'Graph unavailable — client not wired (dev/test), or the directory existence check failed (Graph outage / token or network failure)',
                errorCodes: ['GRAPH_UNAVAILABLE'],
            },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // teams
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/teams',
        tag: 'teams',
        operationId: 'teams_list',
        summary: 'List teams',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { query: listTeamsQuerySchema },
        responses: {
            '200': { description: 'Paginated team list', schema: listTeamsResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'POST',
        path: '/api/teams',
        tag: 'teams',
        operationId: 'teams_create',
        summary: 'Provision a new team',
        description: "Async provisioning — enqueues a `provision-team` job and returns 202 with the attempt's source id: freshly inserted, or the same id as the failed attempt for this name that the call reclaimed. At most one open attempt exists per team name. Authorized via `teams:create` OR (the `team-self-provisioning` flag is enabled AND the caller holds a `team_admin` grant).",
        permission: 'teams:create',
        rateLimitTier: 'teamProvision',
        request: { body: createTeamBodySchema },
        responses: {
            '202': { description: 'Provisioning queued', schema: createTeamResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': {
                description: 'Neither permission nor flag-enabled team_admin',
                errorCodes: ['FORBIDDEN'],
            },
            '404': {
                description: 'One or more `adminUserIds` do not resolve to a user',
                errorCodes: ['USER_NOT_FOUND'],
            },
            '409': {
                description: 'Team name already exists (`TEAM_NAME_TAKEN`); an open attempt for the name is still running (`PROVISION_IN_PROGRESS`) or its job is missing from the queue or no longer running and needs the bullmq-stuck-queue runbook (`PROVISION_STUCK`); a concurrent retry reclaimed the failed attempt first (`PROVISION_RETRY_RACE`); or the prior job moved past the queue between the active check and eviction (`PROVISION_RACED_TO_ACTIVE`)',
                errorCodes: [
                    'TEAM_NAME_TAKEN',
                    'PROVISION_IN_PROGRESS',
                    'PROVISION_STUCK',
                    'PROVISION_RETRY_RACE',
                    'PROVISION_RACED_TO_ACTIVE',
                ],
            },
            '502': {
                description: 'Provisioning queue (Redis) unreachable; retry shortly',
                errorCodes: ['PROVISION_QUEUE_UNREACHABLE'],
            },
        },
    },
    {
        method: 'GET',
        path: '/api/teams/by-name/{name}',
        tag: 'teams',
        operationId: 'teams_get_by_name',
        summary: 'Get a single team by name',
        description: 'Slug-addressed sibling of `teams_get`, returning the identical row shape. Exists because `/teams/:slug` addresses a team by name; without it the UI resolved the slug by scanning a paginated list page, dropping every team outside the first page. See ADR 0009.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { params: getTeamByNameParamsSchema },
        responses: {
            '200': { description: 'Team row', schema: getTeamByNameResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/teams/{id}',
        tag: 'teams',
        operationId: 'teams_get',
        summary: 'Get a single team',
        description: 'Single-resource fetch — same row shape as the list.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { params: teamIdParamSchema },
        responses: {
            '200': { description: 'Team row', schema: getTeamResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
        },
    },
    {
        method: 'PATCH',
        path: '/api/teams/{id}',
        tag: 'teams',
        operationId: 'teams_update',
        summary: 'Edit a team',
        description: 'Team-scoped: a team_admin may patch only their own team; marketplace_admin / super_admin pass globally.',
        permission: 'teams:update',
        rateLimitTier: 'authedWrite',
        request: { params: teamIdParamSchema, body: updateTeamBodySchema },
        responses: {
            '200': { description: 'Updated team row', schema: updateTeamResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
        },
    },
    {
        method: 'DELETE',
        path: '/api/teams/{id}',
        tag: 'teams',
        operationId: 'teams_delete',
        summary: 'Soft-delete a team',
        description: 'Super-admin only. Soft-deletes the team and flips its `plugin_sources` row to `status=failed`. ADO content is preserved.',
        permission: 'teams:delete',
        rateLimitTier: 'authedWrite',
        request: { params: teamIdParamSchema },
        responses: {
            '204': { description: 'Team deleted', empty: true },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/teams/{id}/admins',
        tag: 'teams',
        operationId: 'teams_list_admins',
        summary: 'List team admin grants',
        description: 'Returns the active `team_admin` grant rows for a team. The grant row carries only ids + `createdAt`; UI joins user display fields client-side via `GET /api/users` (which requires `users:view`).',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { params: teamIdParamSchema, query: listTeamAdminsQuerySchema },
        responses: {
            '200': { description: 'Paginated grant list', schema: listTeamAdminsResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/teams/{id}/admins',
        tag: 'teams',
        operationId: 'teams_add_admin',
        summary: 'Grant team_admin to a user',
        description: 'Idempotent on existing non-deleted grants — returns 201 on a fresh insert and 200 on an idempotent re-grant.',
        permission: 'teams:manage_admins',
        rateLimitTier: 'authedWrite',
        request: { params: teamIdParamSchema, body: addTeamAdminBodySchema },
        responses: {
            '200': { description: 'Grant already existed', schema: addTeamAdminResponseSchema },
            '201': { description: 'Grant created', schema: addTeamAdminResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': {
                description: 'Team or user not found',
                errorCodes: ['TEAM_NOT_FOUND', 'USER_NOT_FOUND'],
            },
        },
    },
    {
        method: 'DELETE',
        path: '/api/teams/{id}/admins/{userId}',
        tag: 'teams',
        operationId: 'teams_remove_admin',
        summary: 'Revoke team_admin from a user',
        description: 'Soft-revokes the grant. The service-layer last-admin guard prevents the team from becoming admin-less (409 `LAST_ADMIN`).',
        permission: 'teams:manage_admins',
        rateLimitTier: 'authedWrite',
        request: { params: removeTeamAdminParamsSchema },
        responses: {
            '204': { description: 'Grant revoked', empty: true },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': {
                description: 'Team, user, or grant not found',
                errorCodes: ['TEAM_NOT_FOUND', 'USER_NOT_FOUND', 'GRANT_NOT_FOUND'],
            },
            '409': {
                description: 'Cannot remove the last team admin',
                errorCodes: ['LAST_ADMIN'],
            },
        },
    },
    {
        method: 'GET',
        path: '/api/teams/{id}/reviewers',
        tag: 'teams',
        operationId: 'teams_list_reviewers',
        summary: 'List team reviewers',
        description: 'Returns the active `team_reviewers` association rows for a team. The row carries only ids + `createdAt`; UI joins user display fields client-side via `GET /api/users`.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { params: teamIdParamSchema, query: listTeamReviewersQuerySchema },
        responses: {
            '200': { description: 'Paginated reviewer list', schema: listTeamReviewersResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/teams/{id}/reviewers',
        tag: 'teams',
        operationId: 'teams_add_reviewer',
        summary: 'Add a reviewer to a team',
        description: 'Adds a marketplace user as a PR reviewer. Idempotent on existing non-deleted rows — 201 on a fresh insert, 200 on an idempotent re-add.',
        permission: 'teams:manage_admins',
        rateLimitTier: 'authedWrite',
        request: { params: teamIdParamSchema, body: addTeamReviewerBodySchema },
        responses: {
            '200': { description: 'Reviewer already existed', schema: addTeamReviewerResponseSchema },
            '201': { description: 'Reviewer added', schema: addTeamReviewerResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': {
                description: 'Team or user not found',
                errorCodes: ['TEAM_NOT_FOUND', 'USER_NOT_FOUND'],
            },
        },
    },
    {
        method: 'DELETE',
        path: '/api/teams/{id}/reviewers/{userId}',
        tag: 'teams',
        operationId: 'teams_remove_reviewer',
        summary: 'Remove a reviewer from a team',
        description: 'Soft-removes the reviewer association. No last-reviewer guard — an empty Reviewers team is a valid (PR-gating) state.',
        permission: 'teams:manage_admins',
        rateLimitTier: 'authedWrite',
        request: { params: removeTeamReviewerParamsSchema },
        responses: {
            '204': { description: 'Reviewer removed', empty: true },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': {
                // No USER_NOT_FOUND — the route deliberately skips the user-existence
                // check so an orphan grant from a soft-deleted user stays revocable.
                description: 'Team or association not found',
                errorCodes: ['TEAM_NOT_FOUND', 'GRANT_NOT_FOUND'],
            },
        },
    },
    {
        method: 'GET',
        path: '/api/teams/{id}/members',
        tag: 'teams',
        operationId: 'teams_list_members',
        summary: 'List team members',
        description: "Returns the active member association rows (`team_associations` with `kind='member'`) for a team. Members are a plain, non-RBAC, non-ADO tier — the row carries ids + `createdAt` + embedded `displayName`/`email`, but no `adoSyncPending` (members are never mirrored to ADO).",
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { params: teamIdParamSchema, query: listTeamMembersQuerySchema },
        responses: {
            '200': { description: 'Paginated member list', schema: listTeamMembersResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Team not found', errorCodes: ['TEAM_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/teams/{id}/members',
        tag: 'teams',
        operationId: 'teams_add_member',
        summary: 'Add a member to a team',
        description: 'Adds a marketplace user as a plain team member (no permissions, no ADO sync). Idempotent on existing non-deleted rows — 201 on a fresh insert, 200 on an idempotent re-add. Gated by `teams:manage_admins` (no dedicated member permission).',
        permission: 'teams:manage_admins',
        rateLimitTier: 'authedWrite',
        request: { params: teamIdParamSchema, body: addTeamMemberBodySchema },
        responses: {
            '200': { description: 'Member already existed', schema: addTeamMemberResponseSchema },
            '201': { description: 'Member added', schema: addTeamMemberResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': {
                description: 'Team or user not found',
                errorCodes: ['TEAM_NOT_FOUND', 'USER_NOT_FOUND'],
            },
        },
    },
    {
        method: 'DELETE',
        path: '/api/teams/{id}/members/{userId}',
        tag: 'teams',
        operationId: 'teams_remove_member',
        summary: 'Remove a member from a team',
        description: 'Soft-removes the member association. No last-member guard — a team with zero members is a valid state.',
        permission: 'teams:manage_admins',
        rateLimitTier: 'authedWrite',
        request: { params: removeTeamMemberParamsSchema },
        responses: {
            '204': { description: 'Member removed', empty: true },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': {
                // No USER_NOT_FOUND — the route deliberately skips the user-existence
                // check so an orphan grant from a soft-deleted user stays revocable.
                description: 'Team or association not found',
                errorCodes: ['TEAM_NOT_FOUND', 'GRANT_NOT_FOUND'],
            },
        },
    },
    {
        method: 'GET',
        path: '/api/teams/export',
        tag: 'teams',
        operationId: 'teams_export',
        summary: 'Export teams as CSV',
        description: 'Exports all teams matching the filter + sort params as a `text/csv` attachment. Same filter surface as `teams_list` (search, provisionStatus, sort) but without pagination. Capped at 50 000 rows server-side.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { query: exportTeamsQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // sources
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/sources',
        tag: 'sources',
        operationId: 'sources_list',
        summary: 'List plugin sources (admin)',
        description: 'Paginated admin list of provisioned sources. Supports `sort` (signed comma-joined field: name, status, lastSync, updatedAt) and `status` (comma-joined filter: provisioning, active, failed). Optional `orphaned=true` filters to rows with status=failed AND team_id IS NULL.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { query: listSourcesQuerySchema },
        responses: {
            '200': { description: 'Paginated admin list', schema: listSourcesResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/sources/export',
        tag: 'sources',
        operationId: 'sources_export',
        summary: 'Export sources as CSV',
        description: 'Exports all sources matching the filter + sort params as a text/csv attachment. Same filter surface as sources_list (sort, status, orphaned, search) but without pagination. Capped at 50 000 rows server-side.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { query: exportSourcesQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/sources/{id}',
        tag: 'sources',
        operationId: 'sources_get',
        summary: 'Source detail (admin)',
        description: 'Webhook secret values are never exposed; the row carries `hasPendingSecret` to drive the rotation widget.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { params: getSourceParamsSchema },
        responses: {
            '200': { description: 'Source admin row', schema: getSourceResponseSchema },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Source not found', errorCodes: ['SOURCE_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/sources/{id}/sync-jobs',
        tag: 'sources',
        operationId: 'sources_sync_jobs',
        summary: 'Webhook sync history for a source',
        description: 'Powers operator verification during the §7.5 secret-rotation observation window.',
        permission: 'teams:view',
        rateLimitTier: 'authedRead',
        request: { params: listSyncJobsParamsSchema, query: listSyncJobsQuerySchema },
        responses: {
            '200': { description: 'Paginated sync-job history', schema: listSyncJobsResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Source not found', errorCodes: ['SOURCE_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/sources/{id}/rotate-webhook-secret',
        tag: 'sources',
        operationId: 'sources_rotate_secret',
        summary: 'Rotate webhook secret (two-phase)',
        description: '`phase=begin` writes a new secret to KV + ADO + `webhook_secret_pending` and returns 202; the operator observes deliveries during a 5-minute window; `phase=promote` swaps `webhook_secret_pending` → `webhook_secret`.',
        permission: 'teams:update',
        rateLimitTier: 'authedWrite',
        request: { params: sourceIdParamSchema, body: rotateWebhookSecretBodySchema },
        responses: {
            '200': { description: 'Promote phase completed', schema: rotateWebhookSecretResponseSchema },
            '202': { description: 'Begin phase queued', schema: rotateWebhookSecretResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Source not found', errorCodes: ['SOURCE_NOT_FOUND'] },
            '409': { description: 'No pending secret to promote', errorCodes: ['NO_PENDING_SECRET'] },
            '502': { description: 'Begin failed; row reverted', errorCodes: ['ROTATION_FAILED'] },
        },
    },
    {
        method: 'POST',
        path: '/api/sources/{id}/register-hook',
        tag: 'sources',
        operationId: 'sources_register_hook',
        summary: 'Re-register an ADO webhook for a source (admin backfill)',
        description: 'Backfills the ADO service-hook registration deferred by `provision-team` step 6 when the per-team UAI lacked `ServiceHook:EditSubscriptions` at provision time. On success flips `plugin_sources.webhook_enabled = true` and emits `source.webhook_registered`. Returns the ADO subscription id. See ADR-0003.',
        permission: 'sources:admin',
        rateLimitTier: 'authedWrite',
        request: { params: registerHookParamsSchema },
        responses: {
            '200': {
                description: 'Either the webhook was re-registered (kind: "registered") OR ADO still rejects on the permission-class 400 (kind: "permission_denied" — recoverable: SRE grants the UAI bit, operator retries). The 200/discriminated-union shape replaces the pre-T10 200/403 split per ADR-0003 review.',
                schema: registerHookResponseSchema,
            },
            '403': {
                description: 'Missing `sources:admin` permission (RBAC denial only).',
                errorCodes: ['FORBIDDEN'],
            },
            '404': { description: 'Source not found', errorCodes: ['SOURCE_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/sources/{id}/refresh-template',
        tag: 'sources',
        operationId: 'sources_refresh_template',
        summary: 'PR template updates into an existing team repo',
        description: 'Non-destructive: paths only in the team repo are left untouched (preserves team-authored work). When the template tree matches the team tree exactly the route short-circuits with `prUrl: null` and no PR is opened. The branch name is deterministic (`template/refresh-${shortSha}`) so repeated calls idempotently target the same branch and PR.',
        permission: 'teams:update',
        rateLimitTier: 'authedWrite',
        request: { params: refreshTemplateParamsSchema },
        responses: {
            '200': {
                description: 'Refresh completed (PR opened or no-op)',
                schema: refreshTemplateResponseSchema,
            },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Source not found', errorCodes: ['SOURCE_NOT_FOUND'] },
            '409': { description: 'Source is not active', errorCodes: ['SOURCE_NOT_ACTIVE'] },
            '500': {
                description: 'Template repo has no main branch (`TEMPLATE_EMPTY`) or the team repo has no main branch (`TEAM_REPO_EMPTY`).',
                errorCodes: ['TEMPLATE_EMPTY', 'TEAM_REPO_EMPTY'],
            },
        },
    },
    {
        method: 'POST',
        path: '/api/sources/{id}/reactivate',
        tag: 'sources',
        operationId: 'sources_reactivate',
        summary: 'Reactivate a source whose deleted ADO repo has reappeared',
        description: 'Admin inverse of the `reconcile-sync` auto-retirement (`source.archived_repo_gone`). Fail-closed: confirms the ADO repo exists again via `getRepo` before mutating — a still-missing repo returns 409 `REPO_STILL_GONE`. On success clears `deleted_at`, flips `status` to `active`, un-yanks the plugins the retirement flow yanked, and emits `source.reactivated`. Scoped to repo-gone retirements (matched on the `provision_error` marker), so a team-deleted source is never a candidate (→ 404).',
        permission: 'teams:update',
        rateLimitTier: 'authedWrite',
        request: { params: reactivateSourceParamsSchema },
        responses: {
            '200': {
                description: 'Source reactivated; returns the refreshed admin row + un-yanked plugin count.',
                schema: reactivateSourceResponseSchema,
            },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': {
                description: 'No repo-gone-retired source with this id',
                errorCodes: ['SOURCE_NOT_FOUND'],
            },
            '409': {
                description: 'The ADO repo still does not exist (`REPO_STILL_GONE`) or the source is no longer in a retired state (`SOURCE_NOT_RETIRED`).',
                errorCodes: ['REPO_STILL_GONE', 'SOURCE_NOT_RETIRED'],
            },
            '502': {
                description: 'ADO was unavailable while confirming the repo; retry.',
                errorCodes: ['ADO_UNAVAILABLE'],
            },
        },
    },
    {
        method: 'POST',
        path: '/api/sources/{id}/sync',
        tag: 'sources',
        operationId: 'sources_sync',
        summary: 'Manually enqueue a repo sync for a source',
        description: "Resolves the source repo's current HEAD and enqueues a `sync-repo` job for it, exactly as a webhook push would. The jobId is uniquified per invocation so a manual trigger is never deduped against a still-pending webhook-enqueued job for the same SHA. Replaces the redis-cli manual-enqueue runbook procedure.",
        permission: 'teams:update',
        rateLimitTier: 'authedWrite',
        request: { params: syncSourceParamsSchema, body: syncSourceBodySchema },
        responses: {
            '202': { description: 'Sync job enqueued', schema: syncSourceResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Source not found', errorCodes: ['SOURCE_NOT_FOUND'] },
            '409': { description: 'Source is not active', errorCodes: ['SOURCE_NOT_ACTIVE'] },
            '502': {
                description: 'ADO was unavailable while resolving the repo HEAD; retry.',
                errorCodes: ['ADO_UNAVAILABLE'],
            },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // plugins
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/plugins',
        tag: 'plugins',
        operationId: 'plugins_list',
        summary: 'List plugins (admin)',
        permission: 'plugins:view',
        rateLimitTier: 'authedRead',
        request: { query: listPluginsQuerySchema },
        responses: {
            '200': { description: 'Paginated plugin list', schema: listPluginsResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/plugins/export',
        tag: 'plugins',
        operationId: 'plugins_export',
        summary: 'Export plugins as CSV',
        description: 'Exports all plugins matching the filter + sort params as a `text/csv` attachment. Same filter surface as `plugins_list` (search, status, teamId, categoryId, authorId, sort) but without pagination. Capped at 50 000 rows server-side.',
        permission: 'plugins:view',
        rateLimitTier: 'authedRead',
        request: { query: exportPluginsQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/plugins/by-name/{name}',
        tag: 'plugins',
        operationId: 'plugins_get_by_name',
        summary: 'Get a single plugin by name with detail payload',
        description: "Slug-addressed sibling of `plugins_get`, returning the identical detail payload. Exists because `/catalog/:slug` addresses a plugin by name; without it the UI resolved the slug by scanning a paginated list page and 404'd every plugin outside the first page. Unfiltered by hub-listing status, so pending deep-links still resolve. See ADR 0009.",
        permission: 'plugins:view',
        rateLimitTier: 'authedRead',
        request: { params: getPluginByNameParamsSchema },
        responses: {
            '200': { description: 'Plugin row', schema: getPluginByNameResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Plugin not found', errorCodes: ['PLUGIN_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/plugins/{id}',
        tag: 'plugins',
        operationId: 'plugins_get',
        summary: 'Get a single plugin with detail payload',
        description: 'Single-resource fetch returning the detail payload — the list row plus `readmeContent`, `skills`, and `sourceUrl` — so the plugin detail page renders without a second fetch.',
        permission: 'plugins:view',
        rateLimitTier: 'authedRead',
        request: { params: pluginIdParamSchema },
        responses: {
            '200': { description: 'Plugin row', schema: getPluginResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Plugin not found', errorCodes: ['PLUGIN_NOT_FOUND'] },
        },
    },
    {
        method: 'PATCH',
        path: '/api/plugins/{id}',
        tag: 'plugins',
        operationId: 'plugins_update',
        summary: 'Edit a plugin (description)',
        permission: 'plugins:update',
        rateLimitTier: 'authedWrite',
        request: { params: pluginIdParamSchema, body: updatePluginBodySchema },
        responses: {
            '200': { description: 'Updated plugin row', schema: updatePluginResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Plugin not found', errorCodes: ['PLUGIN_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/plugins/{id}/deprecate',
        tag: 'plugins',
        operationId: 'plugins_deprecate',
        summary: 'Mark a plugin deprecated',
        permission: 'plugins:deprecate',
        rateLimitTier: 'authedWrite',
        request: { params: pluginIdParamSchema, body: deprecatePluginBodySchema },
        responses: {
            '200': { description: 'Lifecycle ack', schema: deprecatePluginResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Plugin not found', errorCodes: ['PLUGIN_NOT_FOUND'] },
            '409': { description: 'Cannot deprecate a yanked plugin', errorCodes: ['INVALID_STATE'] },
        },
    },
    {
        method: 'POST',
        path: '/api/plugins/{id}/yank',
        tag: 'plugins',
        operationId: 'plugins_yank',
        summary: 'Yank a plugin (with mandatory reason)',
        description: 'Removes a plugin from the marketplace manifest. `reason` must be ≥ 10 characters.',
        permission: 'plugins:yank',
        rateLimitTier: 'authedWrite',
        request: { params: pluginIdParamSchema, body: yankPluginBodySchema },
        responses: {
            '200': { description: 'Lifecycle ack', schema: yankPluginResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Plugin not found', errorCodes: ['PLUGIN_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/plugins/{id}/unyank',
        tag: 'plugins',
        operationId: 'plugins_unyank',
        summary: 'Restore a yanked plugin',
        permission: 'plugins:unyank',
        rateLimitTier: 'authedWrite',
        request: { params: pluginIdParamSchema, body: unyankPluginBodySchema },
        responses: {
            '200': { description: 'Lifecycle ack', schema: unyankPluginResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Plugin not found', errorCodes: ['PLUGIN_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/plugins/{id}/unmark-deprecated',
        tag: 'plugins',
        operationId: 'plugins_unmark_deprecated',
        summary: 'Clear `deprecated_at`',
        permission: 'plugins:undeprecate',
        rateLimitTier: 'authedWrite',
        request: { params: pluginIdParamSchema, body: unmarkDeprecatedPluginBodySchema },
        responses: {
            '200': { description: 'Lifecycle ack', schema: unmarkDeprecatedPluginResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Plugin not found', errorCodes: ['PLUGIN_NOT_FOUND'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // submissions
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/submissions',
        tag: 'submissions',
        operationId: 'submissions_list',
        summary: 'List submissions',
        description: "Auth-only at the route layer, then row-level scoped in the service: callers WITH `submissions:view` see the full queue, everyone else is auto-scoped to their own `submitter_id`. A `submitterId` filter is honoured but ANDs with that scope, so a non-admin asking for another user's rows gets an empty page (never a 403). The `submissions:view` permission widens scope; it is not required to call the route.",
        // Documents the elevated read permission that widens scope to the full
        // queue. The route is auth-only at the preHandler (row-level scope in the
        // service), so this is not a hard 403 gate — see the description.
        permission: 'submissions:view',
        rateLimitTier: 'authedRead',
        request: { query: listSubmissionsQuerySchema },
        responses: {
            '200': { description: 'Paginated submissions queue', schema: listSubmissionsResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
        },
    },
    {
        method: 'GET',
        path: '/api/submissions/export',
        tag: 'submissions',
        operationId: 'submissions_export',
        summary: 'Export submissions as CSV',
        description: 'Exports all submissions matching the filter + sort params as a `text/csv` attachment. Same filter surface as `submissions_list` (status, type, submitterId, teamId, categoryId, sort) but without pagination. Capped at 50 000 rows server-side. Also serves MySubmissions export (Plan 3 Task 10) with `submitterId` pre-bound on the UI side.',
        permission: 'submissions:view',
        rateLimitTier: 'authedRead',
        request: { query: exportSubmissionsQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Invalid sort field', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'POST',
        path: '/api/submissions',
        tag: 'submissions',
        operationId: 'submissions_create',
        summary: 'Upload a submission ZIP',
        description: 'Multipart upload (≤ submission cap). Returns 202 + `{submissionId, statusUrl}`. Failures collapse to canonical envelopes (MISSING_FILE / TOO_LARGE / NOT_ZIP / MULTIPLE_FILES / MISSING_MULTIPART / UPLOAD_FAILED).',
        permission: 'plugins:submit',
        rateLimitTier: 'submissionCreate',
        request: {
            multipart: {
                fileFieldName: 'zip',
                fieldsSchema: createSubmissionFieldsSchema,
                description: 'Single `zip` file part plus optional `teamId` field.',
            },
        },
        responses: {
            '202': { description: 'Submission accepted', schema: createSubmissionResponseSchema },
            '400': {
                description: 'Multipart parsing or validation failure',
                errorCodes: ['MISSING_MULTIPART', 'MISSING_FILE', 'MULTIPLE_FILES', 'VALIDATION_ERROR'],
            },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '413': { description: 'Upload exceeded the submission size cap', errorCodes: ['TOO_LARGE'] },
            '415': { description: 'Body is not a ZIP', errorCodes: ['NOT_ZIP'] },
            '429': { description: 'Rate limit exceeded (5/hour/user)', errorCodes: ['RATE_LIMITED'] },
            '502': { description: 'Blob upload or enqueue failed', errorCodes: ['UPLOAD_FAILED'] },
        },
    },
    {
        method: 'GET',
        path: '/api/submissions/{id}',
        tag: 'submissions',
        operationId: 'submissions_get',
        summary: 'Submission status',
        description: 'Polled by `marketplace status` and the UI in-progress card. Auth-only at the route layer; the service returns the row to the submitter (self) or a caller holding `submissions:view`, and 403 FORBIDDEN to anyone else. Existence is confirmed before the 403, so the 404-vs-403 split is not information-leaking.',
        // Elevated read permission for the detail route (was the stale, pre-T16c
        // `plugins:view`). Row-scoped in the service — submitter-self also reads.
        permission: 'submissions:view',
        request: { params: submissionIdParamSchema },
        responses: {
            '200': { description: 'Submission row', schema: getSubmissionResponseSchema },
            '403': {
                description: 'Not the submitter and lacking `submissions:view`',
                errorCodes: ['FORBIDDEN'],
            },
            '404': { description: 'Submission not found', errorCodes: ['SUBMISSION_NOT_FOUND'] },
        },
    },
    {
        method: 'POST',
        path: '/api/submissions/{id}/requeue',
        tag: 'submissions',
        operationId: 'submissions_requeue',
        summary: 'Requeue a failed submission',
        description: 'Recovers `upload_failed` (enqueue stage) or `scan_failed` rows. Returns 422 BLOB_NOT_AVAILABLE when the original blob was never persisted.',
        permission: 'plugins:submit_requeue',
        rateLimitTier: 'submissionRequeue',
        request: { params: submissionIdParamSchema },
        responses: {
            '200': { description: 'Submission requeued', schema: requeueSubmissionResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Submission not found', errorCodes: ['SUBMISSION_NOT_FOUND'] },
            '409': {
                description: 'Submission cannot be requeued from this state',
                errorCodes: ['INVALID_STATE'],
            },
            '422': {
                description: 'Original blob never persisted; resubmit instead',
                errorCodes: ['BLOB_NOT_AVAILABLE'],
            },
        },
    },
    {
        method: 'POST',
        path: '/api/submissions/{id}/approve',
        tag: 'submissions',
        operationId: 'submissions_approve',
        summary: 'Approve a submission',
        description: 'Two-admin guard: a submitter cannot approve their own submission (returns 403 SELF_APPROVAL_FORBIDDEN).',
        permission: 'plugins:approve',
        rateLimitTier: 'authedWrite',
        request: { params: submissionIdParamSchema, body: approveSubmissionBodySchema },
        responses: {
            '200': {
                description: 'Submission transitioned to approving',
                schema: approveSubmissionResponseSchema,
            },
            '403': {
                description: 'Missing permission, scope, or self-approval',
                errorCodes: ['FORBIDDEN', 'SELF_APPROVAL_FORBIDDEN'],
            },
            '404': { description: 'Submission not found', errorCodes: ['SUBMISSION_NOT_FOUND'] },
            '409': {
                description: 'Submission cannot be approved from this state',
                errorCodes: ['INVALID_STATE'],
            },
        },
    },
    {
        method: 'POST',
        path: '/api/submissions/{id}/reject',
        tag: 'submissions',
        operationId: 'submissions_reject',
        summary: 'Reject a submission',
        description: 'Mandatory `reason` (≥ 10 chars). Best-effort blob retag to `status=rejected` post-commit.',
        permission: 'plugins:reject',
        rateLimitTier: 'authedWrite',
        request: { params: submissionIdParamSchema, body: rejectSubmissionBodySchema },
        responses: {
            '200': { description: 'Submission rejected', schema: rejectSubmissionResponseSchema },
            '400': {
                description: 'Validation failure (reason too short)',
                errorCodes: ['VALIDATION_ERROR'],
            },
            '403': { description: 'Missing permission or scope', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Submission not found', errorCodes: ['SUBMISSION_NOT_FOUND'] },
            '409': {
                description: 'Submission cannot be rejected from this state',
                errorCodes: ['INVALID_STATE'],
            },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // categories
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/categories',
        tag: 'categories',
        operationId: 'categories_list',
        summary: 'List plugin categories',
        description: 'Paginated list of active plugin categories (emergent taxonomy; the sync-repo worker find-or-creates rows on first use). Read-only; no audit row.',
        permission: 'plugins:view',
        rateLimitTier: 'authedRead',
        request: { query: listCategoriesQuerySchema },
        responses: {
            '200': { description: 'Paginated category list', schema: listCategoriesResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // flags
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/flags',
        tag: 'flags',
        operationId: 'flags_list',
        summary: 'List feature flags',
        permission: 'flags:view',
        rateLimitTier: 'authedRead',
        request: { query: listFlagsQuerySchema },
        responses: {
            '200': { description: 'Paginated flag list', schema: listFlagsResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'PUT',
        path: '/api/flags/{key}',
        tag: 'flags',
        operationId: 'flags_update',
        summary: 'Update a feature flag',
        description: 'Full replacement. Flags are seeded — keys cannot be created at runtime.',
        permission: 'flags:update',
        rateLimitTier: 'authedWrite',
        request: { params: flagKeyParamSchema, body: updateFlagBodySchema },
        responses: {
            '200': { description: 'Updated flag row', schema: updateFlagResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Flag not found', errorCodes: ['FLAG_NOT_FOUND'] },
        },
    },
    {
        method: 'DELETE',
        path: '/api/flags/{key}',
        tag: 'flags',
        operationId: 'flags_delete',
        summary: 'Delete a feature flag',
        permission: 'flags:update',
        rateLimitTier: 'authedWrite',
        request: { params: flagKeyParamSchema },
        responses: {
            '204': { description: 'Flag deleted', empty: true },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Flag not found', errorCodes: ['FLAG_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/flags/export',
        tag: 'flags',
        operationId: 'flags_export',
        summary: 'Export feature flags as CSV',
        description: 'Exports all matching feature flags as a `text/csv` attachment. Same filter surface as `flags_list` (search, sort, enabled) but without pagination. Capped at 50 000 rows server-side. The `e2e-` prefix filter is preserved — test-only flags are excluded from the export.',
        permission: 'flags:view',
        rateLimitTier: 'authedRead',
        request: { query: exportFlagsQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // audit
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/audit',
        tag: 'audit',
        operationId: 'audit_list',
        summary: 'Read the audit log',
        description: 'Paginated, filter-able audit feed. Auth-only at the route layer, then row-level scoped in the service: callers WITH `audit:view` see all rows, everyone else is auto-scoped to their own `actor_id` (never a 403). Filters AND together; `search` substring-matches across action / resource_id / actor email. The `audit:view` permission widens scope; it is not required to call the route.',
        // Documents the elevated read permission that widens scope to all rows.
        // The route is auth-only at the preHandler (row-level scope in the
        // service), so this is not a hard 403 gate — see the description.
        permission: 'audit:view',
        rateLimitTier: 'authedRead',
        request: { query: listAuditQuerySchema },
        responses: {
            '200': { description: 'Paginated audit log rows', schema: listAuditResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
        },
    },
    {
        method: 'GET',
        path: '/api/audit/export',
        tag: 'audit',
        operationId: 'audit_export',
        summary: 'Export audit log as CSV',
        description: 'Exports all audit log rows matching the filter + sort params as a `text/csv` attachment. Same filter surface as `audit_list` (action, actorId, resourceType, resourceId, search, sort) but without pagination. Capped at 50 000 rows server-side. Row-level scoping applies identically to the list route: non-admins only export rows where `actor_id = principalUserId`.',
        permission: 'audit:view',
        rateLimitTier: 'authedRead',
        request: { query: exportAuditQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // metrics
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/metrics/installs',
        tag: 'metrics',
        operationId: 'metrics_installs',
        summary: 'Top plugins by install count (deprecated)',
        description: '**Deprecated.** Unchanged behaviour, retained for contract stability. The signal behind it is dead: Claude Code installs a plugin by `git clone` of the team repo and never fetches the manifest, so `plugin.manifest_fetched` counts near-zero real installs. Nothing renders from it. A real install signal is tracked as a follow-up (metrics dashboard design §8.1). Trailing window — defaults to 30 days; max 90 days (matches the analytics purge horizon).',
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        request: { query: getMetricsInstallsQuerySchema },
        responses: {
            '200': { description: 'Top-N installs', schema: getMetricsInstallsResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/metrics/team-activity',
        tag: 'metrics',
        operationId: 'metrics_team_activity',
        summary: 'Per-team activity counters (deprecated)',
        description: '**Deprecated.** Unchanged behaviour, retained for contract stability. Rolls up from `submissions`, which is empty in prod because ADO service hooks were never registered, so every counter reads zero. Use `metrics_contributions_by_team` instead — it reads git history. Tracked as a follow-up (metrics dashboard design §8.3).',
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        request: { query: getMetricsTeamActivityQuerySchema },
        responses: {
            '200': { description: 'Per-team activity', schema: getMetricsTeamActivityResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/metrics/summary',
        tag: 'metrics',
        operationId: 'metrics_summary',
        summary: 'Marketplace headline metrics',
        description: "Every headline number on the `/metrics` page, plus `notes` — the per-number caveats, served from the API so the page, a CSV reader and any future consumer state the same thing. `contributionsCollectedThrough`, `sourcesEligible`, `sourcesNeverCollected` and `contributionsStaleAfterHours` report the contributions collector's freshness, so a consumer can tell four states apart that would otherwise all read as a measured zero: collected and current, collected but STALE (the collector has stopped — `contributions-stale`), eligible sources that have never been collected (a structural zero — `contributions-never-collected`), and NO eligible sources at all (nothing to collect, so no nightly run will change the numbers — `contributions-no-eligible-sources`). Freshness is computed over the collector's eligibility set; the contribution aggregates are not, so the two cover different rows.",
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        responses: {
            '200': { description: 'Headline metrics', schema: getMetricsSummaryResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/metrics/users/timeseries',
        tag: 'metrics',
        operationId: 'metrics_users_timeseries',
        summary: 'New / cumulative / active users over time',
        description: 'Week- or month-grained buckets over `users`. Excludes the seeded system actor and soft-deleted rows. `activeUsers` reads `last_login_at`, falling back to `updated_at` for buckets predating that column (flagged by the `active-users-fallback` note on `metrics_summary`).',
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        request: { query: metricsRangeQuerySchema },
        responses: {
            '200': { description: 'Users time series', schema: getMetricsUsersTimeseriesResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/metrics/contributions/timeseries',
        tag: 'metrics',
        operationId: 'metrics_contributions_timeseries',
        summary: 'Commits / merged PRs / contributors over time',
        description: 'Week- or month-grained buckets over `analytics_daily_contributions`, written nightly from ADO git history by the `collect-contributions` worker. Platform-UAI rows (`is_system = true`) are excluded. `contributors` is a ceiling — see the `contributors-ceiling` note.',
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        request: { query: metricsRangeQuerySchema },
        responses: {
            '200': {
                description: 'Contributions time series',
                schema: getMetricsContributionsTimeseriesResponseSchema,
            },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/metrics/contributions/by-team',
        tag: 'metrics',
        operationId: 'metrics_contributions_by_team',
        summary: 'Per-team contribution totals for the window',
        description: 'Per-team commits, merged PRs, contributors, plugin count and last commit for the window, each with a commits-only sparkline on the same buckets as `metrics_contributions_timeseries`. Sorted by commits descending.',
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        request: { query: metricsRangeQuerySchema },
        responses: {
            '200': {
                description: 'Per-team contributions',
                schema: getMetricsContributionsByTeamResponseSchema,
            },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/metrics/plugins/timeseries',
        tag: 'metrics',
        operationId: 'metrics_plugins_timeseries',
        summary: 'Plugins created / cumulative over time',
        description: 'Week- or month-grained buckets over `plugins.created_at`. `plugins.hub_listed_at` is deliberately not used for history — `hub-mirror.ts` nulls and resets it, so it is a current-state marker only.',
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        request: { query: metricsRangeQuerySchema },
        responses: {
            '200': {
                description: 'Plugins time series',
                schema: getMetricsPluginsTimeseriesResponseSchema,
            },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/metrics/export.csv',
        tag: 'metrics',
        operationId: 'metrics_export',
        summary: 'Export the metrics series as CSV',
        description: 'Flat `text/csv` attachment carrying every series for the window (users, contributions, by-team, plugins) on one sheet, keyed by series + period. Same window/grain surface as the series routes, no pagination.',
        permission: 'metrics:view',
        rateLimitTier: 'authedRead',
        request: { query: exportMetricsQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // roles
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'GET',
        path: '/api/roles',
        tag: 'roles',
        operationId: 'roles_list',
        summary: 'List roles',
        permission: 'users:view',
        rateLimitTier: 'authedRead',
        request: { query: listRolesQuerySchema },
        responses: {
            '200': { description: 'Paginated role list', schema: listRolesResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'GET',
        path: '/api/roles/permissions',
        tag: 'roles',
        operationId: 'roles_permissions',
        summary: 'Full permission catalog',
        permission: 'users:view',
        rateLimitTier: 'authedRead',
        responses: {
            '200': { description: 'Permission catalog', schema: listPermissionsResponseSchema },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    {
        method: 'PATCH',
        path: '/api/roles/{name}',
        tag: 'roles',
        operationId: 'roles_update',
        summary: 'Update a role (description + permission set)',
        description: 'Permissions must be present in the seeded catalog (the DB FK on `role_permissions.permission_name` enforces the same rule at write time). Cache fan-out invalidates every user holding the role across replicas.',
        permission: 'users:update_roles',
        rateLimitTier: 'authedWrite',
        request: { params: updateRoleParamsSchema, body: updateRoleBodySchema },
        responses: {
            '200': { description: 'Updated role row', schema: updateRoleResponseSchema },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
            '404': { description: 'Role not found', errorCodes: ['ROLE_NOT_FOUND'] },
        },
    },
    {
        method: 'GET',
        path: '/api/roles/export',
        tag: 'roles',
        operationId: 'roles_export',
        summary: 'Export roles as CSV',
        description: 'Exports all matching roles as a `text/csv` attachment. Same filter surface as `roles_list` (search, sort) but without pagination. Capped at 50 000 rows server-side. Columns: Name, Description, Permissions.',
        permission: 'users:view',
        rateLimitTier: 'authedRead',
        request: { query: exportRolesQuerySchema },
        responses: {
            '200': { description: 'CSV export', csv: {} },
            '400': { description: 'Validation failure', errorCodes: ['VALIDATION_ERROR'] },
            '403': { description: 'Missing permission', errorCodes: ['FORBIDDEN'] },
        },
    },
    // ────────────────────────────────────────────────────────────────────
    // webhooks (anonymous prefix; HTTP Basic against plugin_sources.webhook_secret)
    // ────────────────────────────────────────────────────────────────────
    {
        method: 'POST',
        path: '/webhooks/ado',
        tag: 'webhooks',
        operationId: 'webhooks_ado_push',
        summary: 'ADO push webhook receiver',
        description: 'Receives ADO `git.push` service-hook payloads. HTTP Basic auth: `username = ado_repo_id`, `password = webhook_secret` (constant-time compared against the active or pending value). Enqueues a `sync-repo` job with `jobId = ${sourceId}--${headSha}` for idempotent re-execution.',
        anonymous: true,
        authScheme: 'webhookBasic',
        rateLimitTier: 'webhook',
        request: {
            body: adoPushPayloadSchema,
        },
        responses: {
            '200': {
                description: 'Push accepted; sync-repo enqueued',
                schema: webhookAckResponseSchema,
                raw: true,
            },
            '400': {
                description: 'Validation failure or repo-id mismatch',
                errorCodes: ['VALIDATION_ERROR', 'REPO_ID_MISMATCH'],
            },
            '401': {
                description: 'Webhook authentication failed (distinct codes by failure mode)',
                errorCodes: ['WEBHOOK_AUTH_MISSING', 'WEBHOOK_AUTH_MALFORMED', 'WEBHOOK_AUTH_INVALID'],
            },
            '404': { description: 'Source not found / inactive', errorCodes: ['SOURCE_NOT_FOUND'] },
            '503': { description: 'Enqueue failure; ADO will retry', errorCodes: ['ENQUEUE_FAILED'] },
        },
    },
]);
/**
 * Look up the URL path for a route by its operationId.
 * Used by UI code to derive export/download URLs without embedding
 * literal path strings outside the contracts package.
 *
 * @throws {Error} if no route with the given operationId is registered.
 */
export function getOperationPath(operationId) {
    const match = routeRegistry.find((r) => r.operationId === operationId);
    if (!match)
        throw new Error(`Unknown operationId: ${operationId}`);
    return match.path;
}
//# sourceMappingURL=registry.js.map